import { useContext } from 'react'
import upgrades from '../../../../shared/common/values/upgrades'
import Upgrade from './Upgrade'
import { GameContext, SetUpdateContext } from '../../App'
import checkUpgradeEligibility from '../../../../shared/common/tasks/check_upgrade_eligibility'

export default function UpgradeBar() {
	const update = useContext(SetUpdateContext)
	const gameState = useContext(GameContext)

	if (!gameState) return null
	return (
		<div className="grid w-full grid-cols-1 gap-4 p-4 pt-0 sm:grid-cols-2 lg:grid-cols-3">
			{[...upgrades]
				.sort((a, b) => Number(a.cost) - Number(b.cost))
				.map((upgrade) =>
					checkUpgradeEligibility(upgrade, gameState) ? (
						<Upgrade
							key={upgrade.name}
							contents={upgrade}
							onClick={
								update !== null
									? () => {
											return update({
												id: crypto.randomUUID(),
												type: 'upgrade',
												data: {
													id: upgrade.id
												}
											})
										}
									: () => {
											throw new Error('No update')
										}
							}
						/>
					) : null
				)}
		</div>
	)
}
